import { Component, CUSTOM_ELEMENTS_SCHEMA, input, model, output } from '@angular/core';

import type { MenuLI } from '../../../../../types/menu-li';

@Component({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-side-menu',
  templateUrl: './side-menu.html',
})
export class SideMenu {
  public readonly menuItems = input.required<MenuLI[]>();
  public readonly temperature = input.required<number>();

  public openMyVillagesClicked = output();
  public readonly showMenu = model.required<boolean>();
}
